module.exports = __webpack_public_path__ + "static/media/REFT360.4c364ee6.png";